export enum LoginUserType {
  Normal = 0,
  Anonymous = 1,
  Custom = 2
}